module.exports = __webpack_public_path__ + "3a3f33c9333825c50dc1f7191098fd4c.MP3";